import { fetchWithAuth } from '../utils/fetchWithAuth';

export interface ServiceDeskOption {
  id: number;
  name: string;
  enabled?: boolean;
  hasCampaigns?: boolean;
  /** The desk writes the qualification workflow into Jira (D17). Absent reads as off. */
  hasInterventionQualification?: boolean;
}

export interface ServiceDeskCampaignOption {
  label: string;
  summaryPrefix?: string;
}

export const serviceDesksApi = {
  list: async (): Promise<ServiceDeskOption[]> => {
    const res = await fetchWithAuth('service-desks/all');
    const json = await res.json();
    if (!res.ok || json?.success === false) {
      throw new Error(json?.error || 'Failed to fetch service desks');
    }
    return (json.data ?? []) as ServiceDeskOption[];
  },

  campaigns: async (serviceDeskId: number): Promise<Record<string, ServiceDeskCampaignOption>> => {
    const res = await fetchWithAuth(`service-desks/${serviceDeskId}/campaigns`);
    const json = await res.json();
    if (!res.ok || json?.success === false) {
      throw new Error(json?.error || 'Failed to fetch service desk campaigns');
    }
    return (json.data ?? {}) as Record<string, ServiceDeskCampaignOption>;
  },
};
